import {
  SecurityProfile,
  SecurityProfileResponseEntity,
} from 'utils/src/models';

export const mockPermissions = {
  entity1: {
    perm1: true,
    perm2: false,
    perm3: true,
    perm4: true,
  },
  entity2: {
    perm1: false,
    perm2: false,
  },
  entity3: {},
};

export const mockSecurityProfileResponse: SecurityProfileResponseEntity[] = [
  {
    entityId: '17ffa2fe-7009-40f5-8845-bca1d4f0621f',
    entityName: 'Applications',
    permissions: [
      {
        permissionId: '695a6127-37e5-4832-8eb5-5dee7ea66c12',
        name: 'View',
      },
      {
        permissionId: '21320fa7-c4ac-472d-87c1-de5288d656e8',
        name: 'Add',
      },
      {
        permissionId: 'a4d62ae3-cd58-415a-96ba-ce10fc69dfbd',
        name: 'Edit',
      },
      {
        permissionId: '5f26ec14-adeb-4dd2-a607-90b4eb0156b3',
        name: 'Delete',
      },
    ],
  },
  {
    entityId: '568df83d-4887-424b-8d73-1ccc1b107118',
    entityName: 'Roles',
    permissions: [
      {
        permissionId: 'd63a6421-a80c-467f-a04e-23d6dd6fe192',
        name: 'View',
      },
      {
        permissionId: 'a73c0548-73f2-4364-ae7f-ff4b01d3e6da',
        name: 'Add',
      },
      {
        permissionId: 'cb089d5a-6b37-4478-9d16-f27940ab91f7',
        name: 'Edit',
      },
      {
        permissionId: '0a567799-c429-4c62-9aab-0b32daae6dd1',
        name: 'Delete',
      },
    ],
  },
  {
    entityId: '5634fc41-6df8-47be-813d-17e4d56a16ba',
    entityName: 'Entities',
    permissions: [
      {
        permissionId: '18121d6a-09a7-4af6-9986-30ed100fca1e',
        name: 'View',
      },
      {
        permissionId: '005a68c8-bedd-4719-88bc-90d972e1bafa',
        name: 'Add',
      },
      {
        permissionId: '9f10a99b-968a-4541-a1dc-40d4f37f1629',
        name: 'Edit',
      },
      {
        permissionId: 'e9c9edc0-815b-40e8-b80e-285e5232b4a5',
        name: 'Delete',
      },
    ],
  },
  {
    entityId: 'd90a60c6-3ada-4684-ab28-ed788aae2b6b',
    entityName: 'Permissions',
    permissions: [
      {
        permissionId: '06607efc-1c0c-4cd6-ae61-c69fe277bf5a',
        name: 'View',
      },
      {
        permissionId: '2965c8b4-8e13-4ab6-a14e-591895e2b089',
        name: 'Assign',
      },
    ],
  },
];

export const mockSecurityProfile: SecurityProfile = {
  Applications: { View: true, Add: true, Edit: true, Delete: true },
  Roles: { View: true, Add: true, Edit: true, Delete: true },
  Entities: { View: true, Add: true, Edit: true, Delete: true },
  Permissions: { View: true, Assign: true },
};
